export interface HttpResponse<T> extends Response {
    parsedBody?: T;
    rawBlob?: Blob;
}

async function httpBlob<T>(request: RequestInfo): Promise<HttpResponse<T>> {

    const response: HttpResponse<T> = await fetch(request);

    try {
        response.rawBlob = await response.blob()
    } catch (e) {
        throw new Error(response.statusText);
    }
    return response;
}

export async function APIGetBlob<T>(
    path: string,
    args = {
        method: 'get',
    }
): Promise<HttpResponse<T>> {

    const req: RequestInit = {
        method: args.method,
        headers: []
    }

    return await httpBlob<T>(new Request(path, req));
}

async function httpAPI<T>(request: RequestInfo): Promise<HttpResponse<T>> {

    const response: HttpResponse<T> = await fetch(request);

    try {
        response.parsedBody = await response.json();
    } catch (e) {
        throw new Error(response.statusText);
    }
    return response;
}

export async function APIGet<T>(
    path: string,
    args = {
        method: "get",
    }
): Promise<HttpResponse<T>> {

    const req: RequestInit = {
        method: args.method,
        headers: []
    }

    return await httpAPI<T>(new Request(path, req));
}


export async function APIGetBlobCustomHeader<T>(
    path: string,
    headers: HeadersInit,
    args = {
        method: "get",
    }
): Promise<HttpResponse<T>> {

    const myHeaders = new Headers(headers);

    const req: RequestInit = {
        method: args.method,
        headers: myHeaders
    }

    return await httpBlob<T>(new Request(path, req));
}
